import { render, staticRenderFns } from "./RedirectPage.vue?vue&type=template&id=023761e2&scoped=true&"
import script from "./RedirectPage.vue?vue&type=script&lang=ts&"
export * from "./RedirectPage.vue?vue&type=script&lang=ts&"
import style0 from "./RedirectPage.vue?vue&type=style&index=0&id=023761e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023761e2",
  null
  
)

export default component.exports